/** FR translations for Les Aiguilles Blanches */
const fr: Record<string, string> = {
  // Menu
  subtitle: "Simulateur de Damage",
  startGame: "Commencer",
  resumeGame: "Reprendre",
  newGame: "Nouvelle partie",
  // UNUSED continue: "Continuer",
  settings: "Paramètres",
  controls: "Contrôles",
  changelog: "Nouveautés",
  howToPlay: "Comment jouer",
  fullscreen: "Plein écran",
  fullscreenHint: "Appuyez sur F pour le plein écran",
  exitFullscreen: "Quitter plein écran",
  back: "Retour",
  backToGame: "Retour au jeu",
  // UNUSED loading: "Chargement...",
  inputKeyboard: "✓ Clavier détecté",
  inputKeyboardOff: "✗ Pas de clavier",
  inputTouch: "✓ Écran tactile détecté",
  inputTouchOff: "✗ Aucun écran tactile détecté",
  inputGamepad: "✓ Manette connectée",
  inputGamepadOff: "✗ Pas de manette",
  updateAvailable: "Nouvelle version disponible — toucher pour recharger",
  madeIn: "Fait avec ❄️ en Savoie",
  feedback: "Donner son avis",
  on: "✓ OUI",
  off: "✗ NON",
  zoneClosed: "🚫 ZONE FERMÉE",
  
  // Settings
  language: "Langue",
  accessibility: "Accessibilité",
  highContrast: "Contraste élevé",
  reducedMotion: "Mouvement réduit",
  showFps: "Afficher FPS",
  showDebug: "Infos de débogage",
  skiStyle: "Style",
  skiTricks: "Tricks",
  skiBestCombo: "Meilleur combo",
  quitGame: "Quitter le jeu",
  display: "Affichage",
  displayWindowed: "Fenêtré",
  displayFullscreen: "Plein écran",
  displayBorderless: "Sans bordure",
  colorblindMode: "Daltonisme",
  none: "Aucun",
  deuteranopia: "Deutér.",
  protanopia: "Protan.",
  tritanopia: "Tritan.",
  
  // Controls
  // UNUSED move: "Déplacer",
  moveUp: "Haut",
  moveDown: "Bas",
  moveLeft: "Gauche",
  moveRight: "Droite",
  groom: "Damer",
  winch: "Treuil",
  pause: "Pause",
  keyboard: "Clavier",
  clickToRebind: "Cliquer pour modifier",
  pressKey: "Appuyez sur une touche...",
  pressGamepadButton: "Appuyez sur un bouton de manette...",
  noGamepad: "Aucune manette connectée",
  gamepadButtons: "Manette",
  saved: "Sauvegardé !",
  resetControls: "Réinitialiser",
  controlsReset: "Contrôles réinitialisés !",
  movementSensitivity: "Sensibilité",
  // UNUSED gamepadSupported: "Manette OK",
  touch: "Tactile",
  // UNUSED touchSupported: "Tactile OK",
  keyboardLayout: "Disposition clavier",
  customBindings: "Personnalisé",
  noGamepadConnected: "Aucune manette connectée",
  gamepadDiagnostic: "Test manette",
  connectGamepadDiag: "Connectez une manette pour tester",
  gamepadDiagButtons: "Boutons",
  gamepadDiagSticks: "Joysticks",
  gamepadDiagTriggers: "Gâchettes",

  // Audio
  audio: "Audio",
  masterVolume: "Volume principal",
  musicVolume: "Musique",
  sfxVolume: "Effets sonores",
  engineVolume: "Moteur",
  voiceVolume: "Voix",
  ambienceVolume: "Ambiance",
  mute: "Muet",

  backgroundAudio: "Audio en arrière-plan",
  // Bonus
  bonus: "Bonus",
  skiMode: "Mode de descente",
  ski: "Ski",
  snowboard: "Snowboard",
  random: "Aléatoire",
  skiIt: "Skier !",
  rideIt: "Rider !",
  skiAgain: "Re-skier !",
  rideAgain: "Re-rider !",
  skiRunSpeed: "Vitesse",
  skiRunTime: "Temps",
  skiRunGates: "Portes",
  
  // How to Play hints
  howToPlayMove: "{keys} ou Flèches pour se déplacer",
  howToPlayMoveTouch: "Utilise le D-pad virtuel",
  howToPlayMoveGamepad: "Stick ou D-pad pour se déplacer",
  howToPlayMoveHybrid: "{keys}/Flèches ou D-pad tactile",
  howToPlayGroom: "{groomKey} pour damer la neige",
  howToPlayGroomTouch: "Maintenir le bouton de damage",
  howToPlayGroomGamepad: "pour damer la neige",
  howToPlayGroomHybrid: "{groomKey} ou maintenir le bouton de damage",
  howToPlayFuel: "Surveille carburant et endurance !",
  howToPlayWinch: "{winchKey} près d'un poste pour le treuil",
  howToPlayWinchTouch: "Maintenir le bouton treuil près d'un poste",
  howToPlayWinchGamepad: "près d'un poste pour le treuil",
  howToPlayWinchHybrid: "{winchKey} ou maintenir le bouton treuil près d'un poste",
  
  // Winch
  winchSnapped: "💥 Câble cassé !",
  winchAttached: "🔗 Treuil attaché ! Maintenir {winchKey} pour assistance.",
  winchActive: "TREUIL",
  // UNUSED winchHint: "Appuyez sur {winchKey} près d'un ancrage numéroté pour utiliser le treuil",
  // UNUSED winchHintTouch: "Maintenir 🔗 pour le treuil",
  // UNUSED accessPath: "Route de service",
  // UNUSED toPiste: "Vers la piste",
  
  // Taunts - Cliff falls (emphasize the dramatic fall, insurance headaches, rescue hassle)
  tauntCliff1: "9 tonnes dans le ravin. L'assurance va adorer.",
  tauntCliff2: "Jean-Pierre t'avait dit : 'Pas trop près du bord !' Tu te souviens ?",
  tauntCliff3: "Les pisteurs descendent avec les cordes. Encore.",
  tauntCliff4: "Marie annule ta réservation pour la raclette de ce soir.",
  tauntCliff5: "Thierry calcule déjà le coût des réparations...",
  
  // Taunts - Fuel empty (emphasize planning failure, team disappointment)
  tauntFuel1: "La jauge était sur rouge depuis 10 minutes. Tu regardais quoi ?",
  tauntFuel2: "Émilie t'avait pourtant écrit 'FAIRE LE PLEIN' en majuscules.",
  tauntFuel3: "Même le diesel a ses limites. Toi aussi, apparemment.",
  tauntFuel4: "Jean-Pierre soupire. Il envoie Thierry avec un jerrican.",
  tauntFuel5: "Le soleil se lève. La piste n'est pas damée. Les skieurs arrivent.",
  
  // Taunts - Time limit (emphasize consequences for skiers and competition)
  tauntTime1: "Premier télésiège dans 3... 2... 1... Raté.",
  tauntTime2: "Les skieurs découvrent ta piste. Bosselée. Verglacée. Magnifique.",
  tauntTime3: "Jean-Pierre regarde sa montre, puis toi, puis sa montre.",
  tauntTime4: "La FIS demande pourquoi le slalom est sur de la soupe.",
  tauntTime5: "Tu entends les moniteurs ESF expliquer aux clients pourquoi c'est 'pas de ta faute'.",
  
  // Game
  // UNUSED paused: "Pause",
  resume: "Reprendre",
  quitToMenu: "Retour au menu",
  levelComplete: "Piste damée !",
  levelFailed: "Piste échouée",
  tryAgain: "Réessayer",
  coverage: "Couverture",
  time: "Temps",
  // UNUSED rating: "Note",
  nextLevel: "Piste suivante",
  // UNUSED replay: "Rejouer",
  // UNUSED pressContinue: "Appuyez sur Espace ou touchez pour continuer",
  pauseTitle: "⏸️ Pause",
  restart: "Recommencer",
  skipRun: "Passer la descente",
  newRun: "Nouvelle piste",
  quit: "Quitter",
  menu: "Menu",
  levelSelect: "Plan des pistes",
  locked: "Fermée",
   completeToUnlock: "Complète {name} pour débloquer",
  // UNUSED target: "Objectif",
  tutorial: "École de ski",
  timeUsed: "Temps utilisé",
  excellent: "Excellent !",
  good: "Bien joué !",
  passed: "Réussi",
  bonusFuel: "Carburant utilisé",
  bonusFlawless: "Premier essai",
  bonusSpeed: "Temps",
  bonusWinch: "Utilisations du treuil",
  bonusExplore: "Routes explorées",
  bonusPrecision: "Qualité de damage",
  retry: "Réessayer",
  gameComplete: "Jeu terminé !",
  viewCredits: "Voir les crédits",
  creditsTitle: "Félicitations !",
  creditsSubtitle: "Tu as maîtrisé Les Aiguilles Blanches",
  creditsCreatedBy: "Créé par",
  creditsDevelopedWith: "Développé avec",
  creditsArtDirection: "Direction Artistique",
  creditsRetroInspiration: "Un clin d'œil aux classiques rétro comme SkiFree",
  creditsInspiredBy: "Inspiré par",
  creditsGroomers: "Les dameurs de Savoie",
  creditsDedication: "Pour les équipes de nuit qui préparent les pistes pendant notre sommeil",
  creditsThanks: "Merci d'avoir joué !",
  creditsSeeYou: "À bientôt sur les pistes !",
  creditsLine: "Allez, petit. Le soleil se lève. La montagne est prête.",
  playAgain: "Rejouer",
  skipCredits: "Appuyez sur une touche pour passer",
  
  // Tutorial - Step by step
  tutorialName: "Tutoriel - Premiers Pas",
  tutorialTask: "Apprenez les bases du damage",
  prologueLine: "4h du mat'. La montagne est à toi. Au boulot.",
  prologueSkip: "Appuyez pour continuer",
  tutorialIntro: "Bienvenue aux Aiguilles Blanches !",
  skipTutorial: "⏭️ Passer le tutoriel… Appuyez pour le refaire.",
  skipTutorialGamepad: "⏭️ Passer le tutoriel… Appuyez pour le refaire.",
  tutorialWelcome: "🏔️ Jean-Pierre, chef dameur. Roule sur la piste — utilise {keys} ou les flèches ↑↓←→.",
  tutorialWelcomeTouch: "🏔️ Jean-Pierre, chef dameur. Roule sur la piste — utilise le D-pad à gauche.",
  tutorialWelcomeGamepad: "🏔️ Jean-Pierre, chef dameur. Roule sur la piste — utilise le stick gauche ou le D-pad.",
  // UNUSED   tutorialControls: "🎮 Pour bouger la dameuse, utilise {keys} ou les flèches ↑↓←→.",
  // UNUSED   tutorialControlsTouch: "🎮 Pour bouger la dameuse, utilise le D-pad ◀▲▼▶ à gauche.",
  // UNUSED   tutorialControlsGamepad: "🎮 Pour bouger la dameuse, utilise le stick gauche ou le D-pad.",
  // UNUSED   tutorialMove: "➡️ Allez, essaie ! Déplace-toi sur la piste — toute la neige blanche doit être damée.",
  // UNUSED   tutorialGroomIntro: "✅ Bien joué ! Maintenant, passons au damage.",
  tutorialGroomAction: "❄️ Maintiens {groomKey} en roulant pour damer la neige. Tu verras, ça se fait presque tout seul.",
  tutorialGroomActionTouch: "❄️ Maintiens le bouton de damage à droite en roulant pour damer la neige.",
  tutorialGroomActionGamepad: "❄️ Maintiens {groomKey} en roulant pour damer la neige. Tu verras, ça se fait presque tout seul.",
  tutorialGroomGoal: "📊 Voilà ! Dame au moins 60% avant l'ouverture. Les skieurs arrivent bientôt !",
  // UNUSED   tutorialCoverage: "📊 Tu vois ? La neige devient plus lisse ! Continue à damer la piste.",
  // UNUSED   tutorialHUD: "📈 Regarde le tableau de bord en haut : la barre rouge c'est ton carburant, la verte ton endurance, et la blanche ta couverture. Le chrono tourne !",
  // UNUSED   tutorialGoal: "🎯 Il faut damer au moins 60% de la piste avant l'ouverture. Les skieurs arrivent bientôt !",
  // UNUSED tutorialFuel: "⛽ Attention, rouler consomme du carburant. En mission, passe à la station-service !",
  tutorialComplete: "🏆 Bravo ! Tu maîtrises les bases. Prêt pour ta première vraie mission sur la Piste Verte ?",
  
  // Levels
  level_marmottesName: "Piste Verte - Les Marmottes",
  level_marmottesTask: "Damez la piste débutant",
  level_chamoisName: "Piste Bleue - Le Chamois",
  level_chamoisTask: "Damez efficacement avant l'ouverture",
  level_airZoneName: "Snowpark - Air Zone",
  level_airZoneTask: "Préparez les modules de freestyle",
  level_aigleName: "Piste Rouge - L'Aigle",
  level_aigleTask: "Damez le terrain pentu, gérez le carburant",
  level_glacierName: "Piste Rouge - Le Glacier",
  level_glacierTask: "Apprenez à utiliser le treuil en pente",
  level_tubeName: "Half-pipe - Le Tube",
  level_tubeTask: "Entretenez le half-pipe pour la compétition",
  level_verticaleName: "Piste Noire - La Verticale",
  level_verticaleTask: "Opération nocturne avec treuil",
  level_colDangereuxName: "Zone Avalanche - Col Dangereux",
  level_colDangereuxTask: "Préparez la zone à haut risque",
  level_tempeteName: "Tempête - Récupération",
  level_tempeteTask: "Dégagez les pistes après la tempête",
  level_coupeDesAiguillesName: "Coupe des Aiguilles - Finale FIS",
  level_coupeDesAiguillesTask: "Préparez toutes les pistes pour la compétition",
  
  // Hazards
  cliffFall: "⚠️ ATTENTION ! Tu es tombé dans le ravin ! Mission échouée.",
  fuelEmpty: "⛽ PANNE SÈCHE ! Plus une goutte de diesel...",
  // UNUSED avalancheZone: "ZONE AVALANCHE",
  riskLevelHigh: "FORT",
  avalancheWarning: "⚠️ DANGER ! Le manteau neigeux est instable ! Sortez de la zone !",
  avalancheTrigger: "🏔️💨 AVALANCHE DÉCLENCHÉE ! Évacuation impossible !",
  steepWarning: "⚠️ PENTE RAIDE ! Utilise le treuil ({winchKey}) ou tu vas glisser !",
  steepWarningNoWinch: "⚠️ PENTE RAIDE ! Ralentis et utilise les chemins de service pour contourner !",
  tumble: "🔄 TONNEAU ! La dameuse a basculé sur la pente !",
  
  // Taunts - Tumble/Rollover (emphasize winch lesson, expensive damage)
  tauntTumble1: "Le treuil, c'est pas décoratif. C'est pour les pentes comme ça.",
  tauntTumble2: "Thierry contemple les dégâts. Il ne dit rien. C'est pire.",
  tauntTumble3: "Jean-Pierre t'avait montré comment s'ancrer. Tu dormais ?",
  tauntTumble4: "Une PistenBully, ça coûte 400 000€. Enfin, ça coûtait.",
  tauntTumble5: "La pente te semblait gérable ? La dameuse n'était pas d'accord.",
  featureDestroyedKicker: 'Tu as roulé sur un module du snowpark ! Le kicker est détruit.',
  featureDestroyedRail: 'Tu as roulé sur un module du snowpark ! Le rail est détruit.',
  tauntFeature1: 'Ce module a pris trois heures à construire. Tu l\'as aplati en trois secondes.',
  tauntFeature2: 'Émilie va avoir deux mots à te dire à propos de ce module.',
  tauntFeature3: 'L\'équipe du snowpark vient de te regarder détruire leur chef-d\'œuvre.',
  tauntFeature4: 'Les modules, c\'est pour les skieurs, pas pour les dameuses. Contourne-les !',
  tauntFeature5: 'Un module en moins pour la compétition de demain.',
  bonusPipeMastery: 'Maîtrise du halfpipe',
  
  // Taunts - Avalanche (emphasize danger, respect for mountain)
  tauntAvalanche1: "La montagne pardonne rarement. Elle n'a pas pardonné.",
  tauntAvalanche2: "Le bulletin Météo France disait risque 4. Tu l'as lu ?",
  tauntAvalanche3: "Les pisteurs retrouveront la dameuse au printemps. Peut-être.",
  tauntAvalanche4: "Marie écoute l'alerte radio. Elle sait déjà que c'est toi.",
  tauntAvalanche5: "Les pisteurs avaient sécurisé le secteur. Toi, tu as tout fichu en l'air.",

  // Taunts - Ski wipeout (fun, self-deprecating)
  tauntSkiWipeout1: "Yard sale classique. Le matos partout, la dignité nulle part.",
  tauntSkiWipeout2: "La falaise n'en avait rien à faire de ta technique.",
  tauntSkiWipeout3: "Les pisteurs rigolent déjà. Ils ont tout vu.",
  tauntSkiWipeout4: "Voilà ce qui arrive quand on skie sa propre piste.",
  tauntSkiWipeout5: "Même les bouquetins ont grimacé en voyant l'atterrissage.",
  
  // Dialogues
  jeanPierreIntro: "T'as bien bossé sur le tutoriel, petit. Maintenant c'est du vrai — la Verte, avec du chrono et du carburant.",
  level_marmottesMid: "Tu vois cette lueur sur les crêtes ? Le premier jour. Le meilleur moment — juste toi, la machine, et la montagne qui se réveille.",
  level_chamoisIntro: "Salut, moi c'est Émilie — JP te met sur la bleue. Allez, montre que tu sais faire autre chose que du velours sur la verte.",
  level_airZoneIntro: "Le snowpark c'est MON domaine — on va leur préparer un terrain de fou ! Chaque module doit être nickel, les riders comptent sur nous.",
  level_aigleIntro: "L'Aigle, c'est du sérieux. Surveille ton carburant. Les chemins de dameuse permettent de remonter la piste — repère les piquets jaunes et noirs.",
  level_glacierIntro: "Salut, c'est Thierry — responsable sécurité. Le Glacier, c'est raide. J'ai vérifié chaque ancrage. Appuie sur {winchKey} à côté d'un poteau pour accrocher le treuil — et par pitié, ne lâche pas.",
  level_glacierIntroTouch: "Salut, c'est Thierry — responsable sécurité. Le Glacier, c'est raide. J'ai vérifié chaque ancrage. Appuie sur le bouton treuil à côté d'un poteau — et par pitié, ne lâche pas.",
  level_tubeIntro: "Demain c'est le contest au Tube ! Je veux des parois propres, une lèvre nette, et zéro bourrelet.",
  level_verticaleIntro: "Nuit sur La Verticale : pente raide, bords dangereux. Treuil obligatoire — accroche-toi aux 3 ancrages et reste dans l'axe.",
  level_colDangereuxIntro: "Risque avalanche élevé sur le Col — protocole sécurité avalanche activé. Reste hors des zones chargées et respecte les limites.",
  level_tempeteIntro: "La tempête est passée. Prends un vin chaud, ça va être long !",
  level_coupeDesAiguillesIntro: "C'est le grand soir. La FIS inspecte demain. Toutes les pistes doivent être parfaites — montre-moi ce que t'as appris.",
  marieWelcome: "Viens te réchauffer Chez Marie. Une bonne tartiflette !",
  marieIntro: "Salut ! Moi c'est Marie, je tiens le restaurant en haut de la piste. Passe quand tu veux — un bon plat chaud, ça recharge les batteries !",
  
  // Changelog
  changelog_20260219_date: "19 février 2026",
  changelog_20260219: "🎬 Prologue pour les nouveaux joueurs\n📖 Tutoriel simplifié\n🌦️ Météo aléatoire au menu\n🔗 Pistes du jour partageables\n🎥 Générique cinématique",
  changelog_20260222_date: "22 février 2026",
  changelog_20260222: "🚩 Rééquilibrage des portes de slalom\n💬 Bouton de feedback",
  changelog_20260223_date: "23 février 2026",
  changelog_20260223: "📲 Installe le jeu sur ton appareil pour jouer hors ligne",
  changelog_20260220_date: "20 février 2026",
  changelog_20260220: "🗺️ Plan des pistes\n🎿 Vocabulaire de station",
  changelog_20260217_date: "17 février 2026",
  changelog_20260217: "🏔️ Sept formes de piste\n🎯 Variété de génération\n⚡ Descente plus fluide",
  changelog_20260216_date: "16 février 2026",
  changelog_20260216: "🎲 Pistes du jour",
  changelog_20260215_date: "15 février 2026",
  changelog_20260215: "⚡ Refonte du rendu nocturne\n📱 Boutons tactiles en ski\n⌨️ Détection disposition clavier",
  changelog_20260214_date: "14 février 2026",
  changelog_20260214: "🎪 Tricks et combos\n🏂 Schuss et physique du halfpipe\n👁️ Meilleur contraste des pistes\n📱 Damage auto au treuil (tactile)\n♿ Mode contraste élevé",
  changelog_20260213_date: "13 février 2026",
  changelog_20260213: "🚩 Portes de slalom\n🏔️ Sauts à ski\n⚡ Performances améliorées\n🎹 Musique nocturne au piano\n🔊 Volume moteur réglable",
  changelog_20260212_date: "12 février 2026",
  changelog_20260212: "📋 Plan des pistes\n🔗 Câble de treuil cassable\n🕹️ Diagnostic manette\n🍽️ Les plats de Marie\n❄️ Exposition au froid",
  changelog_20260211_date: "11 février 2026",
changelog_20260211: "⛷️ Descente à ski après le damage\n🎯 Qualité de damage\n🏔️ Zones raides colorées\n🏗️ Snowpark et tricks",
  changelog_20260210_date: "10 février 2026",
  changelog_20260210: "🎵 Musique et effets sonores\n🔈 Réglages de volume\n⏱️ Temps de piste auto-calibrés\n⏭️ Option sauter le tutoriel\n🏔️ Refonte des zones d'avalanche",
  changelog_20260209_date: "9 février 2026",
  changelog_20260209: "🏔️ Écrans victoire/défaite alpins\n❄️ Neige de tempête sur les éléments\n🏆 Bonus sans faute\n🔊 Ambiances météo et faune",
  changelog_20260208_date: "8 février 2026",
  changelog_20260208: "📊 Nouveau tableau de bord\n🏔️ Le Glacier et Coupe des Aiguilles\n🦅 Faune alpine\n🎨 Portraits des personnages\n🎮 Navigation clavier/manette",
  changelog_20260207_date: "7 février 2026",
  changelog_20260207: "🎨 Interface rétro\n🎯 Objectifs bonus\n🕹️ Remappage boutons manette\n🎮 Navigation manette",
  changelog_20260206_date: "6 février 2026",
  changelog_20260206: "🛤️ Chemins de dameuse praticables\n🕹️ Joystick virtuel\n🌍 5 langues complètes",
  changelog_20260205_date: "5 février 2026",
  changelog_20260205: "🏔️ Falaises rocheuses\n🌙 Phares de nuit\n🔗 Mécanique de treuil\n⌨️ Navigation clavier",
  changelog_20260204_date: "4 février 2026",
  changelog_20260204: "🎮 Support manette\n📱 Contrôles tactiles\n💪 Endurance\n💾 Sauvegarde\n♿ Accessibilité",
  changelog_20260203_date: "3 février 2026",
  changelog_20260203: "🚜 Lancement : 9 pistes, école de ski\n❄️ Damage, carburant, avalanches\n🏆 Crédits et progression",
  // Key names
  key_space: "ESPACE",
  key_shift: "MAJ",
  key_ctrl: "CTRL",
  key_alt: "ALT",
  key_enter: "ENTRÉE",
  key_tab: "TAB",
  key_esc: "ÉCHAP",
  key_del: "SUPPR",
  dailyRuns: "Pistes du jour",
  dailyRuns_dailyShift: "Service du jour",
  dailyRuns_randomRun: "Piste aléatoire",
  dailyRuns_rank: "Difficulté",
  dailyRuns_seed: "Code",
  // UNUSED   dailyRuns_start: "Lancer le contrat",
  dailyRuns_locked: "Termine toutes les pistes pour débloquer",
  dailyRuns_lockedShared: "Termine toutes les pistes pour débloquer les Pistes du jour et jouer cette piste partagée",
  // UNUSED   dailyRun_levelName: "Contrat",
  dailyRun_levelTask: "Damez la piste jusqu'à l'objectif de couverture",
  dailyRuns_briefing: "Briefing",
  dailyRuns_target: "Objectif",
  dailyRuns_timeLimit: "Temps",
  dailyRuns_weather_clear: "Ciel dégagé",
  dailyRuns_weather_light_snow: "Neige légère",
  dailyRuns_weather_storm: "Tempête",
  dailyRuns_night: "Service de nuit",
  dailyRuns_day: "Service de jour",
  rank_green: "Verte",
  rank_blue: "Bleue",
  rank_red: "Rouge",
  rank_black: "Noire",
  rank_park: "Park",
  share: "Partager",
  copied: "Lien copié !",
  playSharedSeed: "Partie partagée",
  dailyRunBriefingJP: "Cette piste doit être prête avant l'ouverture des remontées. Au boulot.",
  dailyRunBriefingThierry: "Fais gaffe là-haut — passages raides et neige instable. Reste vigilant.",
  dailyRunBriefingMarie: "Ça va cailler cette nuit. Passe te réchauffer au restaurant si besoin.",
  dailyRunBriefingEmilie: "Encore une piste à préparer. Essaie de battre mon chrono !",
};

export default fr;
